import {IMAGE_TYPE} from "@/common/utils/constants";

export function getLogoImageObject(images) {
	return getImageByType(images, IMAGE_TYPE.logo)[0];
}

export function getMainImageObject(images) {
	return getImageByType(images, IMAGE_TYPE.main)[0];
}

export function getMainImageUrl(images) {
	const image = getImageByType(images, IMAGE_TYPE.main)[0];

	return image ? image.objectUrl : image;
}

export function getLogoUrl(images) {
	const image = getImageByType(images, IMAGE_TYPE.logo)[0];

	return image ? image.objectUrl : image;
}

export function getCarouselImageObjects(images) {
	return getImageByType(images, IMAGE_TYPE.other);
}

function getImageByType(images, type) {
	return images.filter(image => image.type === type);
}
